import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

const ScrollToTop = () => {

    const { pathname } = useLocation();

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [pathname]);

    const scrollClick = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <div>
            <a id="back2Top" className="top-scroll" title="Back to top" onClick={scrollClick}><i className="ti-arrow-up"></i></a>
        </div>
    )
}

export default ScrollToTop